import { render, staticRenderFns } from "./RevShareBilling.vue?vue&type=template&id=156bfbc0&scoped=true&"
import script from "./RevShareBilling.vue?vue&type=script&lang=js&"
export * from "./RevShareBilling.vue?vue&type=script&lang=js&"
import style0 from "./RevShareBilling.vue?vue&type=style&index=0&id=156bfbc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156bfbc0",
  null
  
)

export default component.exports